import { useEffect, useState } from 'react'
import { useOfflineTool } from './dexie'

const useOfflineElementTool = ({ dataType, url, elementId }) => {
  const [offlineData, setOfflineData] = useState<{ [key: string]: any } | null>(null)

  useEffect(() => {
    ;(async () => {
      const offlineResponse = await getOfflineData()
      if (offlineResponse) {
        setOfflineData(offlineResponse)
      }
    })()
  }, [elementId])

  const offlineTool = useOfflineTool()

  const getOfflineData = async () => {
    const offlineResponse = await offlineTool.getElement(dataType, url, elementId)
    return offlineResponse
  }

  const deleteOfflineData = async () => {
    const offlineResponse = await getOfflineData()
    if (offlineResponse) {
      await offlineTool.deleteElement(offlineResponse.id)
      setOfflineData(null)
    }
  }

  const saveOfflineData = async (
    fields: { field: string; value: string | boolean | number | string[] | boolean[] }[]
  ) => {
    const offlineResponse = await getOfflineData()

    const data = fields.reduce((acc, { field, value }) => {
      return { ...acc, [field]: value }
    }, {})

    if (offlineResponse) {
      await offlineTool.updateElement({
        id: offlineResponse.id,
        url: url,
        name: dataType,
        elementId,
        data: { ...offlineResponse.data, ...data }
      })
    } else {
      await offlineTool.addElement({
        url: url,
        name: dataType,
        elementId,
        data
      })
    }
  }

  const refetch = async () => {
    const offlineResponse = await getOfflineData()
    return offlineResponse
  }

  return { offlineData, deleteOfflineData, saveOfflineData, refetch }
}

export default useOfflineElementTool
